import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import api from '@/api';
import { NotFoundScreen } from '@/common/ErrorScreen';
import { TitleWithQuestion } from '@/common/TitleWithQuestion';
import StudentPendingFollowUpsRequestsTable from '@/tables/StudentPendingFollowUpsRequestsTable';
import { GroupHeaderWrapper } from '~/styles/layoutElements';

export const Route = createFileRoute(
  '/_app/_users/members/$memberId/follow-ups/pending-requests',
)({
  component: MemberPendingRequestsScreen,
});

function MemberPendingRequestsScreen() {
  const { t } = useTranslation();
  const { memberId } = Route.useParams();
  const studentId = Number(memberId);

  const { data: access, isLoading } = api.getStudentFollowUpsAccess.useQuery({
    path: { student_id: studentId },
  });

  if (isLoading) return null;
  if (access?.can_view !== true) return <NotFoundScreen />;

  return (
    <Container>
      <GroupHeaderWrapper>
        <TitleWithQuestion
          title={t('wbs.pending-follow-up-requests')}
          placement="student_follow_ups"
        />
      </GroupHeaderWrapper>
      <StudentPendingFollowUpsRequestsTable
        studentId={studentId}
        studentName={access.display_name ?? ''}
      />
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 40px;
`;
